import { FormGroup } from '@angular/forms';
import { rmaShareReplay } from '@rma/generic/rxjs/operators/rma-share-replay';
import { catchError, combineLatest, exhaustMap, filter, map, Observable, of, OperatorFunction, take, tap } from 'rxjs';
import type { SubmissionFormOptions, SubmissionResult } from '../domain/submission-form';
import { FormGroupControls, FormGroupValue } from '../domain/typed-form';
import { BaseSubmissionForm } from './base-submission-form';

export class InferredSubmissionForm<TForm extends FormGroup, TResult> extends BaseSubmissionForm<FormGroupValue<TForm>, TResult> {
  public get controls(): FormGroupControls<TForm> {
    return this.form.controls;
  }

  public constructor(
    public override readonly form: TForm,
    submitOperator: OperatorFunction<FormGroupValue<TForm>, TResult>,
    initialValue: Partial<FormGroupValue<TForm>> | Observable<Partial<FormGroupValue<TForm>>> = {},
    options: Partial<SubmissionFormOptions>,
  ) {
    super(form, submitOperator, initialValue, options);
  }

  createFormSubmissionStream(
    valid$: Observable<boolean>,
    operator: OperatorFunction<FormGroupValue<TForm>, TResult>,
  ): Observable<SubmissionResult<TResult>> {
    return combineLatest([valid$, this.submitting$]).pipe(
      filter(([valid, submitting]) => valid && submitting),
      exhaustMap(() =>
        of(this.form.value).pipe(
          operator,
          map((response) => ({ type: 'success' as const, payload: response })),
          catchError((error) => {
            console.error(error);
            return of({
              type: 'error' as const,
              error: this.getServerError(error),
            });
          }),
          take(1),
        ),
      ),
      tap(({ type }) => this.setSubmissionState(type)),
      rmaShareReplay(),
    );
  }
}
